import { useEffect, useState } from 'react';
import type { TraceabilityApiClient } from '../api/TraceabilityApiClient';
import type { Machine } from '../type/Machine';

export function useMachines(traceabilityApiClient: TraceabilityApiClient | null): Machine[] {
  const [machines, setMachines] = useState<Machine[]>([]);

  useEffect(() => {
    if (!traceabilityApiClient) return;
    const ac = new AbortController();
    traceabilityApiClient
      .machineReadAll({}, { signal: ac.signal })
      .then((res) => {
        if (ac.signal.aborted) return;
        if (res.ok && res.data?.machines)
          setMachines(res.data.machines.map((m: { machine: Machine }) => m.machine));
      })
      .catch(() => {});
    return () => ac.abort();
  }, [traceabilityApiClient]);

  return machines;
}
